module.exports = __webpack_public_path__ + "img/证书打印.b74d3894.png";